import React, { useEffect, useState } from "react";
import { formatPrice } from "../../lib/format";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Single source of truth for order statuses, mirrored from
// `ORDER_STATUSES` in backend/server.py. Changing one without the other
// will let the admin save a status the API rejects (400). The labels
// match `ORDER_STATUS_LABELS` so the customer-facing string in /mon-compte
// reads the same as what the admin chooses here.
const STATUSES = [
  { value: "pending_payment", label: "En attente de paiement" },
  { value: "paid",             label: "En cours de préparation" },
  { value: "shipped",          label: "Expédiée" },
  { value: "delivered",        label: "Livrée" },
  { value: "cancelled",        label: "Annulée" },
  { value: "refunded",         label: "Remboursée" },
];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const load = () => api.get("/admin/orders").then(r=>setOrders(r.data));
  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try { await api.put(`/admin/orders/${id}`, patch); toast.success("Mis à jour ✿"); load(); }
    catch { toast.error("Erreur"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-10">
      <p className="overline text-berulia-rosedeep">BERULIA</p>
      <h1 className="font-heading text-3xl sm:text-4xl mt-2 mb-8">Commandes</h1>
      <div className="bg-white border border-berulia-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-berulia-beigewarm"><tr><th className="text-left p-3">N°</th><th className="text-left p-3">Date</th><th className="text-left p-3">Cliente</th><th className="text-left p-3">Total</th><th className="text-left p-3">Statut</th><th className="text-left p-3">Suivi</th><th className="text-right p-3">Actions</th></tr></thead>
          <tbody>
            {orders.map(o => (
              <React.Fragment key={o.id}>
                <tr className="border-t border-berulia-border">
                  <td className="p-3 overline">{o.order_number}</td>
                  <td className="p-3">{new Date(o.created_at).toLocaleDateString("fr-FR")}</td>
                  <td className="p-3">{o.customer_name}<br/><span className="text-xs text-berulia-inkmuted">{o.customer_email}</span></td>
                  <td className="p-3">{formatPrice(o.total)}</td>
                  <td className="p-3">
                    <select value={o.status} onChange={e=>update(o.id, {status:e.target.value})} data-testid={`status-${o.order_number}`} className="border border-berulia-border px-2 py-1 bg-white">
                      {STATUSES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                  </td>
                  <td className="p-3">
                    <input defaultValue={o.tracking_number} placeholder="N° de suivi" onBlur={e=>{if(e.target.value!==o.tracking_number) update(o.id, {tracking_number:e.target.value})}} className="border border-berulia-border px-2 py-1 w-32"/>
                  </td>
                  <td className="p-3 text-right"><button onClick={()=>setExpanded(expanded===o.id?null:o.id)} className="overline link-underline">Détail</button></td>
                </tr>
                {expanded === o.id && (
                  <tr><td colSpan={7} className="p-6 bg-berulia-beigewarm/40">
                    <div className="grid md:grid-cols-3 gap-6">
                      <div><p className="overline mb-2">Articles</p>{o.items.map((it,i)=>(<p key={i} className="text-sm">• {it.name} · {it.size} × {it.quantity} — {formatPrice((it.unit_price*it.quantity))}</p>))}</div>
                      <div><p className="overline mb-2">Facturation</p><p className="text-sm">{o.billing_address?.line1}<br/>{o.billing_address?.postal_code} {o.billing_address?.city}</p></div>
                      <div><p className="overline mb-2">Livraison ({o.carrier})</p><p className="text-sm">{o.shipping_address?.line1}<br/>{o.shipping_address?.postal_code} {o.shipping_address?.city}</p></div>
                    </div>
                  </td></tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
